import React from "react"
import ReactMarkdown from "markdown-to-jsx"
import PropTypes from "prop-types"

import { handleLinks } from "../helpers"

// ! Use this component sparingly!
// Most Markdown is already available as prerendered HTML in the Gatsby GraphQL layer.

const Markdown = ({ children }) => {
  return (
    <ReactMarkdown
      options={{
        forceBlock: true,
        overrides: {
          a: handleLinks,
        },
        wrapper: React.Fragment,
      }}
    >
      {children}
    </ReactMarkdown>
  )
}

Markdown.propTypes = {
  children: PropTypes.string.isRequired,
}

export default Markdown
